import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input, OnDestroy, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, Validator, AbstractControl, ValidationErrors } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';

import { HintDialogComponent } from '../hint-dialog/hint-dialog.component';

export interface PEOption {
  code: string;
  description: string;
}

@Component({
  selector: 'ap-pre-existing-condition',
  templateUrl: './pre-existing-condition.component.html',
  host: {
    'class': 'ap-pre-existing-condition',
  },
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: PreExistingConditionComponent,
      multi: true
    }
  ]
})
export class PreExistingConditionComponent implements OnChanges, OnDestroy, ControlValueAccessor, Validator {

  isDisabled: boolean;
  options: Array<PEOption>;
  _value: string;

  @Input() heading: string;
  @Input() subheading: string;
  @Input() hint: string;
  @Input() yesLabel: string;
  @Input() noLabel: string;
  @Input() notSureLabel: string;
  @Input() value: PEOption;
  @Output() changed = new EventEmitter<string>();

  constructor(private dialog: MatDialog) { }

  ngOnDestroy(): void { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.yesLabel || changes.noLabel || changes.notSureLabel) {
      this.options = [];

      if (this.yesLabel != null) {
        this.options.push({ code: 'Yes', description: this.yesLabel });
      }
      if (this.noLabel != null) {
        this.options.push({ code: 'No', description: this.noLabel });
      }
      if (this.notSureLabel != null) {
        this.options.push({ code: 'Maybe', description: this.notSureLabel });
      }

      this.writeValue(this._value);
    }
  }

  showHintDialog(): void {
    this.dialog.open(HintDialogComponent, {
      data: { hint: this.hint }
    });
  }

  onChange(value: PEOption): void {
    this.value = value;

    if (this._onChange != null) {
      this._onChange(value.code);
    }

    this.changed.emit(value.code);

    if (this._onTouched != null) {
      this._onTouched();
    }
  }

  //#region ControlValueAccessor

  _onTouched = () => { };
  _onChange = (value: any) => { };

  writeValue(value: string): void {
    this._value = value;

    if (this.options != null) {
      this.value = this.options.find(p => p.code === value);
    }
  }

  registerOnChange(fn: any): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  //#endregion
  // Need this boilerplate code to make up level form validation work properly
  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }

  registerOnValidatorChange?(fn: () => void): void { }
}
